import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { useUpdateDelay } from '../../hooks/use-update-delay';

import type { TSmeCarouselDots } from './models';

export const SmeCarouselDots: FC<TSmeCarouselDots> = ({
    autoplay,
    className,
    delay,
    onChange,
    selectedIndex,
    styles,
    total,
}) => {
    useUpdateDelay({ delay, styles });

    return (
        <div className={cn(className, styles.dots)}>
            {Array.from({ length: total }, (_, index) => (
                <button
                    key={index}
                    aria-label={
                        index === selectedIndex
                            ? `Активный слайд #${index + 1}`
                            : `Переключиться на слайд #${index + 1}`
                    }
                    className={cn(styles.dot, {
                        [styles.active]: index === selectedIndex,
                        [styles.autoplay]: autoplay,
                    })}
                    data-test-id={`dot-${index}`}
                    onClick={() => {
                        onChange?.(index);
                    }}
                />
            ))}
        </div>
    );
};
